import { NavItem } from './nav-item/nav-item';
import { Permissions } from 'src/app/common/permissions';

export const navItems: NavItem[] = [
  {
    navCap: 'Inicio',
  },
  {
    displayName: 'Clientes',
    iconName: 'user',
    permissions: [Permissions.ViewAllClients, Permissions.ViewMyPortfolio],
    children: [
      {
        displayName: 'Todos',
        iconName: 'user-search',
        route: '/dashboards/clients',
        permissions: [Permissions.ViewAllClients]
      },  
      {
        displayName: 'Sin Ejecutivo',
        iconName: 'briefcase-off',
        route: '/dashboards/cliensOutEjecutive',
        permissions: [Permissions.ViewSinAsignar]
      },    
      {
        displayName: 'Mi Portafolio',
        iconName: 'briefcase',
        route: '/dashboards/portfolio',
        permissions: [Permissions.ViewMyPortfolio]
      },    
       
    ],
  },
    {
    displayName: 'Deudores',
    iconName: 'user-dollar',
    permissions: [Permissions.ViewDebtors],
    children: [
      {
        displayName: 'Todos',
        iconName: 'user-search',
        permissions: [Permissions.ViewAllDebtors],
        route: '/dashboards/allDebtors',
      },
      {
        displayName: 'Configuracion',
        iconName: 'settings',
        permissions: [Permissions.ViewDebtorsConfig],
        children: [
          {
            displayName: 'Favoritos',
            iconName: 'heart-dollar',
            route: '/dashboards/debtors-Favorites',
            permissions: [Permissions.ViewDebtorsConfig]
          },
          {
            displayName: 'Lista Negra',
            iconName: 'heart-x',
            route: '/dashboards/debtors-BlackList',
            permissions: [Permissions.ViewDebtorsConfig]
          },
        ]
      },  
    ],
  },
  /*{
    displayName: 'Deudores',
    iconName: 'point',
    permissions: [Permissions.ViewDebtors],
    children: [
      {
        displayName: 'Deudores Favoritos',
        route: '/dashboards/debtors-Favorites',
        permissions: [Permissions.ViewDebtors]
      },  
      {
        displayName: 'Lista Negra',
        route: '/dashboards/debtors-BlackList',
        permissions: [Permissions.ViewDebtors]
      },
       
    ],
  },*/
  {
    displayName: 'Minutas',
    iconName: 'clipboard-text',
    route: '/dashboards/view-minutes',
    permissions: [Permissions.ViewAllMinutes]
  },
  {
    displayName: 'Garantías',
    iconName: 'perspective',
    permissions: [Permissions.ViewAllIssueWarranties || Permissions.ManageSalesQuotes],
    children: [
      {
        displayName: 'Todas',
        route: '/dashboards/warranties',
        iconName: 'file-search',
        permissions: [Permissions.ViewAllIssueWarranties]
      },
      {
        displayName: 'CRM / Tratos',
        route: '/dashboards/dealsEvaluation',
        iconName: 'file-like',
        permissions: [Permissions.ViewDealsCRM]
      },
      {
        displayName: 'Cotizaciones',
        route: '/dashboards/simulations',
        iconName: 'calculator',
        permissions: [Permissions.ManageSalesQuotes]
      }
    ]
  },
  {
    displayName: 'Factoring',
    iconName: 'perspective',
    permissions: [Permissions.ViewAllFactoringCompanies,Permissions.ViewFactoringOpportunities],
    children: [
      {
        displayName: 'Oportunidades',
        route: '/dashboards/factoring-opportunities',
        iconName: 'zoom-money',
        permissions: [Permissions.ViewFactoringOpportunities]
      },
      {
        displayName: 'Cesionarios',
        route: '/dashboards/factoring',
        iconName: 'user-share',
        permissions: [Permissions.ViewAllFactoringCompanies]
      }
    ],
  },
  {
    displayName: 'Seguridad',
    iconName: 'shield',
    permissions: [Permissions.ViewRolesManagement, Permissions.ViewUsersManagement],
    children: [
      {
        displayName: 'Roles',
        iconName: 'user-bolt',
        route: '/security/roles',
        permissions: [Permissions.ViewRolesManagement]
      },
      {
        displayName: 'Usuarios',
        iconName: 'user-cog',
        route: '/security/users',
        permissions: [Permissions.ViewUsersManagement]
      },
      {
        displayName: 'Reglas Aprobación',
        iconName: 'list-check',
        route: '/setting/minute-approval-rules',
        permissions: [Permissions.ViewAllMinuteApprovalRules]
      },
      {
        displayName: 'Documentos',
        iconName: 'file-settings',
        // route: '/setting/documents',
        permissions:[Permissions.ViewAlDocumentTypes],
        children: [
          {
            displayName: 'Tipos de Documentos',
            iconName: 'file-info',
            route: '/setting/documents',
            permissions: [Permissions.ViewAlDocumentTypes]
          },
          {
            displayName: 'Plantillas',
            iconName: 'file-delta',
            route: '/setting/document-templates',
            permissions: [Permissions.ViewAlDocumentTypes]
          },
        ]
      }
    ]
  },
];


export const navItemsClient: NavItem[] = [
  {
    navCap: 'Bienvenido'
  },
  {
    displayName: 'Compañia/s',
    iconName: 'building',
    route: 'dashboards/cliente/companies',
  },
  /*{
    displayName: 'Configuración',
    iconName: 'settings',
    route: 'dashboards/cliente/config',
  }*/
]
